// extracted by mini-css-extract-plugin
export var modal = "styles-module__modal___TJhxd";
export var close = "styles-module__close___rCOBr";
export var enterDone = "styles-module__enterDone___tDf8a";
export var exit = "styles-module__exit___q5U4h";